import { registerPlugin } from '@capacitor/core';

export interface TabItem {
  id: string;
  label: string;
  icon: string;
  path: string;
}

export interface NativeTabBarPlugin {
  isAvailable(): Promise<{ available: boolean }>;
  show(options: { items: TabItem[] }): Promise<{ success: boolean }>;
  hide(): Promise<{ success: boolean }>;
  selectTab(options: { index: number }): Promise<{ success: boolean }>;
  updateBadge(options: { index: number; badge?: string }): Promise<{ success: boolean }>;
  addListener(
    eventName: 'tabSelected',
    listenerFunc: (data: { index: number; path: string }) => void,
  ): Promise<{ remove: () => void }>;
}

const NativeTabBar = registerPlugin<NativeTabBarPlugin>('NativeTabBar', {
  web: {
    async isAvailable() {
      return { available: false };
    },
    async show() {
      return { success: false };
    },
    async hide() {
      return { success: false };
    },
    async selectTab() {
      return { success: false };
    },
    async updateBadge() {
      return { success: false };
    },
    async addListener() {
      return { remove: () => {} };
    },
  },
});

export default NativeTabBar;
